module.exports = __webpack_public_path__ + "static/img/6bg_4.b3a338d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/6bg_4.png
// module id = 739
// module chunks = 1